import React, { useState } from "react";
import { db } from "../services/firebase";
import { collection, query, where, getDocs, updateDoc } from "firebase/firestore";
import { sendOTP, verifyOTP } from "../services/otpService";
import "./Login.css";
import { useNavigate } from "react-router-dom";
import bcrypt from "bcryptjs";
import Logo from "../JMIlogo.png";

const ForgotPassword = () => {
  const [mobile, setMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [otpId, setOtpId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const nav = useNavigate();

  // Send OTP for forgot password
  const sendOtp = async () => {
    if (mobile.length !== 10 || isNaN(mobile)) {
      alert("Enter a valid 10-digit mobile number");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Check if mobile exists in database
      const q = query(collection(db, "sellers"), where("mobile", "==", mobile));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        alert("This mobile number is not registered. Please register first.");
        setLoading(false);
        return;
      }

      // Send OTP via Cloud Function
      const response = await sendOTP({
        mobile,
        useCase: "FORGOT_PASSWORD",
        validity: 10,
        params: {},
      });

      if (response.success) {
        setOtpId(response.data.otpId);
        setOtpSent(true);
        alert("OTP sent successfully! Please check your mobile.");
      } else {
        setError(response.message || "Failed to send OTP");
        alert(response.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error("Error generating OTP:", err);
      setError(err.message || "Failed to generate OTP");
      alert(err.message || "Failed to generate OTP");
    } finally {
      setLoading(false);
    }
  };

  // Verify OTP and Reset Password
  const verifyOtpAndResetPassword = async () => {
    if (!otpId) {
      alert("Please request OTP first");
      return;
    }

    if (!otp || !password || !confirmPass) {
      alert("Please fill all fields: OTP, New Password, and Confirm Password.");
      return;
    }

    if (password !== confirmPass) {
      alert("New Password and Confirm Password must match.");
      return;
    }

    if (password.length < 6) {
      alert("Password must be at least 6 characters long.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      // Verify OTP
      const verifyResponse = await verifyOTP({
        otpId,
        otp,
      });

      if (!verifyResponse.success) {
        setError(verifyResponse.message || "Invalid OTP");
        alert(verifyResponse.message || "Invalid OTP");
        setLoading(false);
        return;
      }

      // OTP verified - now update password
      const q = query(collection(db, "sellers"), where("mobile", "==", mobile));
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty) {
        alert("Seller not found");
        setLoading(false);
        return;
      }

      const sellerDoc = querySnapshot.docs[0];

      // Hash the new password
      const newPasswordHash = await bcrypt.hash(password, 10);

      // Update the seller's password
      await updateDoc(sellerDoc.ref, {
        passwordHash: newPasswordHash,
        updatedAt: new Date(),
      });

      alert(`Password successfully reset for +91 ${mobile}!`);

      // Navigate to login page
      nav("/login", { replace: true });

    } catch (err) {
      console.error("Password reset error:", err);
      setError(err.message || "Password reset failed");
      alert(err.message || "Password reset failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <h1 className="title">
        <img src={Logo} alt="" className="logo" srcset="" />
      </h1>
      <p className="subtitle">Seller Desk</p>
      <div className="login-box">
        <h2>Forgot Password</h2>

        {!otpSent ? (
          <>
            <label>Mobile</label>
            <input
              type="tel"
              maxLength="10"
              placeholder="Enter Mobile Number"
              value={mobile}
              onChange={(e) => setMobile(e.target.value.replace(/\D/g, ""))}
            />

            <button
              className="login-btn"
              onClick={sendOtp}
              disabled={loading}
            >
              {loading ? "Checking Account..." : "Send Reset OTP"}
            </button>
          </>
        ) : (
          <>
            <label>OTP</label>
            <input
              type="number"
              placeholder="Enter OTP (sent via SMS)"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
              maxLength={6}
            />

            <label>New Password (Min. 6 characters)</label>
            <input
              type="password"
              placeholder="Enter new password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />

            <label>Confirm New Password</label>
            <input
              type="password"
              placeholder="Confirm new password"
              value={confirmPass}
              onChange={(e) => setConfirmPass(e.target.value)}
            />

            <button
              className="login-btn"
              onClick={verifyOtpAndResetPassword}
              disabled={loading}
            >
              {loading ? "Resetting Password..." : "Verify & Reset Password"}
            </button>
          </>
        )}
      </div>

      {error && <p className="error">{error}</p>}

      <p className="register-link">
        Remember your password?{" "}
        <span onClick={() => nav("/login")}>Go to Login</span>
      </p>

      <p className="support">
        <img src="/whatsapp.svg" alt="whatsapp" className="whatsapp-icon" />
        <span onClick={() => window.open("https://wa.me/919053999090", "_blank")}>
          Need help?
        </span>
        Contact Seller Support
      </p>
    </div>
  );
};

export default ForgotPassword;